import React, { Fragment } from 'react';
import SelectField from './SelectField';

const options = [{
  id: 'my-training',
  title: 'My Training'
}, {
  id: 'certifications',
  title: 'Certifications'
}, {
  id: 'your-action-items',
  title: 'Your Action Items'
}, {
  id: 'training-in-progress',
  title: 'Training in Progress'
}, {
  id: 'your-transcript',
  title: 'Your Transcript'
}, {
  id: 'your-assigned-training',
  title: 'Your Assigned Training'
}, {
  id: 'your-inbox',
  title: 'Your Inbox'
}, {
  id: 'social-feed',
  title: 'Social Feed'
}, {
  id: 'your-tasks',
  title: 'Your Tasks'
}, {
  id: 'your-upcoming-sessions',
  title: 'Your Upcoming Sessions'
}].sort((a, b) => a.title.localeCompare(b.title));

const CornerstoneWidgetField = (props) => {
  const { input } = props;

  const handleOnChange = (value) => {
    input.onChange(value);
  };

  const getDefaultOption = (id) => options.find((option) => option.id === id);

  return (
    <Fragment>
      <SelectField
        defaultValue={getDefaultOption(input.value)}
        label="Select Cornerstone Widget"
        items={options}
        omitCollapsible={true}
        afterOnChange={handleOnChange}
      />
    </Fragment>
  );
};

export default CornerstoneWidgetField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/CornerstoneWidgetField.js